import { addBusinessDays, addMinutes } from "date-fns";

export const EXPECTED_MINUTES_FOR_INSTANT_PAYOUT = 30;
export const EXPECTED_DAYS_FOR_STANDARD_PAYOUT = 3;

export interface GetExpectedPayoutDateParams {
  paymentDate: Date;
  isPayoutInstant: boolean;
}

export function getExpectedPayoutDate(params: GetExpectedPayoutDateParams): Date {
  const { paymentDate, isPayoutInstant } = params;

  if (isPayoutInstant) {
    return addMinutes(paymentDate, EXPECTED_MINUTES_FOR_INSTANT_PAYOUT);
  }

  return addBusinessDays(paymentDate, EXPECTED_DAYS_FOR_STANDARD_PAYOUT);
}
